export const Address = () => (
  <address>
    <small>(407) 729-3649</small>
    <br />
    Austin, TX
    <br />
    <small>victoriacleanings.com</small>
  </address>
);